export const technologyMinMax = {
  "Air-air heat pump": {
    min: {
      "Total investment cost": 1000,
      "Annual fixed O&M cost": 0,
      "Technology lifetime": 8,
    },
    max: {
      "Total investment cost": 15000,
      "Annual fixed O&M cost": 600,
      "Technology lifetime": 30,
    },
  },
  "Air-water heat pump": {
    min: {
      "Total investment cost": 3000,
      "Annual fixed O&M cost": 0,
      "Technology lifetime": 8,
    },
    max: {
      "Total investment cost": 20000,
      "Annual fixed O&M cost": 600,
      "Technology lifetime": 30,
    },
  },
  "Gas condensing boiler": {
    min: {
      "Total investment cost": 1000,
      "Annual fixed O&M cost": 0,
      "Technology lifetime": 10,
    },
    max: {
      "Total investment cost": 8000,
      "Annual fixed O&M cost": 600,
      "Technology lifetime": 30,
    },
  },
  "Ground-source heat pump": {
    min: {
      "Total investment cost": 7000,
      "Annual fixed O&M cost": 0,
      "Technology lifetime": 8,
    },
    max: {
      "Total investment cost": 30000,
      "Annual fixed O&M cost": 600,
      "Technology lifetime": 30,
    },
  },
  "Oil condensing boiler": {
    min: {
      "Total investment cost": 1000,
      "Annual fixed O&M cost": 0,
      "Technology lifetime": 10,
    },
    max: {
      "Total investment cost": 8000,
      "Annual fixed O&M cost": 600,
      "Technology lifetime": 30,
    },
  },
  "Pellet Stove": {
    min: {
      "Total investment cost": 2000,
      "Annual fixed O&M cost": 0,
      "Technology lifetime": 8,
    },
    max: {
      "Total investment cost": 30000,
      "Annual fixed O&M cost": 600,
      "Technology lifetime": 30,
    },
  },
  "Pellet boiler (automated feed)": {
    min: {
      "Total investment cost": 2000,
      "Annual fixed O&M cost": 0,
      "Technology lifetime": 8,
    },
    max: {
      "Total investment cost": 30000,
      "Annual fixed O&M cost": 600,
      "Technology lifetime": 30,
    },
  },
  "Pellet boiler (manual feed)": {
    min: {
      "Total investment cost": 2000,
      "Annual fixed O&M cost": 0,
      "Technology lifetime": 8,
    },
    max: {
      "Total investment cost": 30000,
      "Annual fixed O&M cost": 600,
      "Technology lifetime": 30,
    },
  },
  "Solar thermal combi system": {
    min: {
      "Total investment cost": 8000,
      "Annual fixed O&M cost": 0,
      "Technology lifetime": 10,
    },
    max: {
      "Total investment cost": 25000,
      "Annual fixed O&M cost": 600,
      "Technology lifetime": 35,
    },
  },
  "Solar thermal water heater": {
    min: {
      "Total investment cost": 3000,
      "Annual fixed O&M cost": 0,
      "Technology lifetime": 10,
    },
    max: {
      "Total investment cost": 12000,
      "Annual fixed O&M cost": 600,
      "Technology lifetime": 35,
    },
  },
  "Thermally-driven air-water heat pump": {
    min: {
      "Total investment cost": 3000,
      "Annual fixed O&M cost": 0,
      "Technology lifetime": 8
    },
    max: {
      "Total investment cost": 18000,
      "Annual fixed O&M cost": 600,
      "Technology lifetime": 30
    }
  }
};

export const fuelTypes = {
  "Oil condensing boiler": "Oil",
  "Gas condensing boiler": "Gas",
  "Air-air heat pump": "Electricity",
  "Air-water heat pump": "Electricity",
  "Ground-source heat pump": "Electricity",
  "Pellet Stove": "Pellet",
  "Pellet boiler (automated feed)": "Pellet",
  "Pellet boiler (manual feed)": "Pellet",
   "Thermally-driven air-water heat pump": "Gas"
};


export const technologyColorIndex = {
  "Air-air heat pump": 0,
  "Air-water heat pump": 1,
  "Gas condensing boiler": 3,
  "Ground-source heat pump": 2,
  "Oil condensing boiler": 4,
  "Pellet Stove": 12,
  "Pellet boiler (automated feed)": 13,
  "Pellet boiler (manual feed)": 14,
  "Solar thermal combi system": 9,
  "Solar thermal water heater": 10,
  "Thermally-driven air-water heat pump": 15
};
